import DeleteSVG from './assets/DeleteSVG';
import PlusSVG from './assets/PlusSVG';
import LockSVG from './assets/LockSVG';
import SaveSVG from './assets/SaveSVG';
import ArrowSVG from './assets/ArrowSVG';
import ShareSVG from './assets/ShareSVG';
import PlaySVG from './assets/PlaySVG';
import DownloadSVG from './assets/DownloadSVG';
import PauseSVG from './assets/Pause';
import BurgerMenu from 'assets/icons/sidebar-icons/BurgerMenu';
import TabletSideBarToggle from './assets/TabletSideBarToggle';
import ConnectSVG from './assets/ConnectSVG';
import UploadFileSVG from 'assets/icons/table-icons/UploadFileSVG';
import Sync from './assets/Sync';
import TestConnection from './assets/TestConnection';
import MoreSvg from './assets/more';
import Delete2SVG from 'assets/icons/table-icons/Delete2SVG';
import EyeSVG from 'assets/icons/inputs/EyeSVG';
import EditTableSVG from 'assets/icons/table-icons/EditTableSVG';
import SqlSVG from './assets/SqlSVG';

const svgMap = {
  delete: DeleteSVG,
  save: SaveSVG,
  plus: PlusSVG,
  lock: LockSVG,
  arrow: ArrowSVG,
  share: ShareSVG,
  play: PlaySVG,
  pause: PauseSVG,
  'burger-menu': BurgerMenu,
  'tablet-toggle': TabletSideBarToggle,
  connect: ConnectSVG,
  upload_file: UploadFileSVG,
  sync: Sync,
  testConnection: TestConnection,
  download: DownloadSVG,
  more: MoreSvg,
  delete2: Delete2SVG,
  eye: EyeSVG,
  edit: EditTableSVG,
  sql: SqlSVG,
};

const getSvg = (type, className = '') => {
  const SvgComponent = svgMap[type] || DeleteSVG;
  return (props) => <SvgComponent {...props} className={className} />;
};
export { getSvg };
